import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Mail, Phone, Globe, Calendar } from 'lucide-react';
import { TenantDetails } from '@/types/tenant.types';
import { formatDate } from '@/lib/formatters';

interface TenantInfoCardProps {
  tenant: TenantDetails;
}

export function TenantInfoCard({ tenant }: TenantInfoCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          معلومات الشريك
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex items-center gap-2 text-sm">
            <Globe className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">النطاق:</span>
            <span className="font-medium">{tenant?.subdomain}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">الهاتف:</span>
            <span className="font-medium" dir="ltr">{tenant?.contact_info?.phone || '-'}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">البريد:</span>
            <span className="font-medium">{tenant?.contact_info?.email || '-'}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">تاريخ الإنشاء:</span>
            <span className="font-medium">{formatDate(tenant?.created_at)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
